module.exports = __webpack_public_path__ + "img/ambulancetopview.49d3bd18.png";